import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/layouts/HomePage.vue'
import { getCurrentProfile } from '../lib/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/projets',
    name: 'Projets',
    component: () => import('../components/views/Projets.vue')
  },
  {
    path: '/competences',
    name: 'Competences',
    component: () => import('../components/views/Competences.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../components/views/Contact.vue')
  },
  {
    path: '/mentions-legales',
    name: 'MentionsLegales',
    component: () => import('../components/views/MentionsLegales.vue')
  },
  {
    path: '/conditions-utilisation',
    name: 'ConditionsUtilisation',
    component: () => import('../components/views/ConditionsUtilisation.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../components/admin/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../components/admin/Dashboard.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },

]

// Route de connexion admin secrète, définie dans .env.local (non versionné)
const adminRoute = process.env.VUE_APP_ADMIN_ROUTE
if (adminRoute) {
  routes.push({
    path: `/${adminRoute}`,
    name: 'AdminLogin',
    component: () => import('../components/auth/AdminLogin.vue')
  })
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Guard de navigation : confort d'affichage uniquement,
// la vraie protection des données est assurée par la RLS Supabase
router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth) return true

  try {
    const profile = await getCurrentProfile()
    if (!profile) return '/'
    if (to.meta.requiresAdmin && profile.role !== 'admin') return '/'
    return true
  } catch (err) {
    console.error('Erreur de vérification de session:', err)
    return '/'
  }
})

export default router
